import { AccordionDesignTokens } from '@primeng/themes/types/accordion';

export default {
    root: {
        transitionDuration: '{transition.duration}',
    },
    panel: {
        borderWidth: '0',
        borderColor: '{content.border.color}',
    },
    header: {
        color: '{primary.500}', //changed by mazars
        hoverColor: '{primary.500}', //changed by mazars
        activeColor: '{primary.500}', //changed by mazars
        padding: '1.125rem',
        fontWeight: '700',
        borderRadius: '3px', //changed by mazars
        borderWidth: '0 0 0 9px', //changed by mazars
        borderColor: '{primary.500}', //changed by mazars
        focusRing: {
            width: '{focus.ring.width}',
            style: '{focus.ring.style}',
            color: '{focus.ring.color}',
            offset: '{focus.ring.offset}',
            shadow: 'inset {focus.ring.shadow}',
        },
        toggleIcon: {
            color: '{primary.500}', //changed by mazars
            hoverColor: '{primary.500}', //changed by mazars
            activeColor: '{primary.500}', //changed by mazars
            activeHoverColor: '{primary.500}', //changed by mazars
        },
        first: {
            topBorderRadius: '3px', //changed by mazars
            borderWidth: '0 0 0 9px', //changed by mazars
        },
        last: {
            topBorderRadius: '3px', //changed by mazars
            borderWidth: '0 0 0 9px', //changed by mazars
        },
    },
    content: {
        borderWidth: '0', //changed by mazars
        borderColor: '{content.border.color}',
        background: '{content.background}',
        color: '{text.color}',
        padding: '1.125rem',
    },
    colorScheme: {
        light: {
            header: {
                background: '{surface.0}', //changed by mazars
                hoverBackground: '{surface.0}', //changed by mazars
                activeBackground: '{surface.0}', //changed by mazars
                activeHoverBackground: '{surface.0}', //changed by mazars
                activeHoverColor: '{primary.500}' //changed by mazars
            },
        },
        dark: {
            header: {
                background: '{surface.800}',
                hoverBackground: '{surface.700}',
                activeBackground: '{surface.800}',
                activeHoverBackground: '{surface.700}',
            },
        },
    },
    css: ({ dt }) => `
        

    `,
} as AccordionDesignTokens;
